import API from './API.js'
import axios from 'axios'

export default class ActivityUserAnswer extends API {
  constructor() {
    super('activity-user-answer')
  }
  async report(params) {
    // console.log("api", params);
    try {
      const response = await axios.get(`activity-user-answer-report`, { params })
      return response.data
    } catch (error) {
      if (error.response) {
        console.log(error.response.data.message); // => the response payload 
      }
    }
  }
}
